import { Component, OnInit } from '@angular/core';
import { IonNav, ModalController } from '@ionic/angular';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { AddToOrderBaseComponent } from '../add-to-order-base.component';
import { PopoverHelperService } from '@shared/helpers/popover.helpers';
import { ModalService } from '@shared/services/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { OrderService } from '@order/services/order.service';
import moment from 'moment';
import { UserService } from '@app/user/services';
import { FEATURES } from '@shared/constants/splitio-features';

@Component({
  selector: 'app-add-to-order-modal-desktop-tablet',
  templateUrl: './add-to-order-modal-desktop-tablet.component.html',
  styleUrls: ['./add-to-order-modal-desktop-tablet.component.scss'],
})
export class AddToOrderModalDesktopTabletComponent
  extends AddToOrderBaseComponent
  implements OnInit
{
  addToOrderModalForm: FormGroup;
  minDeliveryDate: Date | string;
  currentPickupDate: Date | String;
  poRegex = new RegExp('^[-0-9a-zA-Z ]{1,20}$');
  defaultPoFeatureFlag = FEATURES.split_dynamic_default_po.name;

  constructor(
    nav: IonNav,
    datePipe: DatePipe,
    modalController: ModalController,
    modalService: ModalService,
    orderService: OrderService,
    popoverHelperService: PopoverHelperService,
    translate: TranslateService,
    platformService: PlatformService,
    panAppState: PanAppState,
    fb: FormBuilder,
    userService: UserService,
  ) {
    super(
      nav,
      datePipe,
      modalController,
      modalService,
      orderService,
      popoverHelperService,
      translate,
      platformService,
      panAppState,
      fb,
      userService,
    );
  }
  ngOnInit(): void {
    let formatMinDate = moment().startOf('day').format('YYYY-MM-DDTHH:mm');
    this.minDeliveryDate = formatMinDate;
    this.currentPickupDate = formatMinDate;

    this.addToOrderModalForm = this.fb.group({
      selectedDeliveryDate: new FormControl(
        moment.utc(this.nextDeliveryDate).format('YYYY-MM-DDTHH:mm'),
      ),
      poNumber: new FormControl(''),
      saveDefaultPo: new FormControl(false),
    });

    super.loadDefaultPoNumber().subscribe(defaultPoNumber => {
      if (defaultPoNumber) {
        this.addToOrderModalForm.patchValue({
          poNumber: defaultPoNumber,
        });
      }
    });
  }
}
